import React, { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";

/**
 * Renders CountUp only after the element is in the viewport and mounted,
 * avoiding react-countup's "target is null" error with enableScrollSpy.
 */
const AnimatedCountUp = ({
  end,
  start = 0,
  duration = 4,
  separator,
  suffix = "",
  ...rest
}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <span ref={ref}>
      {inView ? (
        <CountUp
          start={start}
          end={end}
          duration={duration}
          separator={separator}
          {...rest}
        />
      ) : (
        start
      )}
      {suffix}
    </span>
  );
};

export default AnimatedCountUp;
